import React from 'react';
import { motion } from 'framer-motion';
const HOTMART = 'https://pay.hotmart.com/O103704589E';
const STEPS = [{
  icon: '📂',
  text: 'Abrís el material'
}, {
  icon: '🌿',
  text: 'Comprendés la energía'
}, {
  icon: '👐',
  text: 'Practicás con claridad'
}, {
  icon: '💫',
  text: 'Integrás Reiki a tu vida'
}];
export function SolutionSection() {
  return <section className="bg-gray-900 text-white py-20 md:py-28 px-4" data-id="element-176">
      <div className="container mx-auto max-w-3xl text-center" data-id="element-177">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-178">
          MegaPack Reiki
          <br className="hidden md:block" data-id="element-179" />
          <span className="text-amber-400" data-id="element-180">Formación Completa</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg md:text-xl text-gray-400 mb-14 leading-relaxed max-w-2xl mx-auto" data-id="element-181">
          Un sistema paso a paso para que cualquier persona pueda iniciarse en
          Reiki con seguridad, integrar la energía a su vida y avanzar con
          confianza.
        </motion.p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-14" data-id="element-182">
          {STEPS.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white/5 border border-white/10 rounded-2xl p-6 text-center" data-id="element-183">
              <div className="text-4xl mb-4" data-id="element-184">{step.icon}</div>
              <p className="font-semibold text-white text-sm md:text-base leading-snug" data-id="element-185">
                {step.text}
              </p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-xl md:text-2xl font-bold text-amber-400 mb-10" data-id="element-186">
          Sin improvisar. Sin dudas. Sin confusión.
        </motion.p>

        <motion.a href={HOTMART} target="_blank" rel="noopener noreferrer" whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.97
      }} className="inline-block px-10 py-5 bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-black font-extrabold text-xl rounded-full shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:shadow-[0_0_50px_rgba(245,158,11,0.6)] transition-all" data-id="element-187">
          👉 QUIERO EMPEZAR AHORA
        </motion.a>
      </div>
    </section>;
}